import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDeclineDetails extends Layout {
    panel1: Panel;
    reasonTextbox: Textbox;
    remarksTextbox: Textbox;
    sourceEdiDeclineCodes: DataSource;
}
